import AdminConceptsComponent from "../../../Components/Admin/concepts";

export default function ConceptsAdmin() {
	return <AdminConceptsComponent />;
}
